module.exports = __webpack_public_path__ + "static/media/ic-phone.285a0d12.webp";